module.exports = __webpack_public_path__ + "static/media/2.37a0b824.jpg";